<div>
    <textarea [(ngModel)]="this.data.misNoteCantiere"></textarea>
  </div>
  <div class="buttons">
    <button mat-raised-button (click)="saveMission()" color="primary">SALVA</button>
    <button mat-raised-button (click)="close()">ANNULLA E CHIUDI</button>
  </div>
  
